import styled from '@emotion/styled';
import color from 'src/theme/color';

export const DialogTitle = styled.h2`
    text-align: center;
    font-weight: bold;
    color: ${color.white};
    font-size: 20px;
    margin: 0 0 20px 0;
`;

export const DialogContent = styled.div`
    padding: 20px 24px;
    text-align: center;
`;

export const DialogContentText = styled.p`
    font-size: 14px;
    color: ${color.white};
    line-height: 1.5;
    margin: 0;
`;

export const DialogActions = styled.div`
    display: flex;
    justify-content: center;
    gap: 10px;
    padding: 0 24px 20px 24px;
`;

export const CancelButton = styled.button`
    padding: 10px 20px;
    font-size: 14px;
    font-weight: 500;
    color: ${color.white};
    background-color: ${color.blackRock};
    border: none;
    border-radius: 20px;
    cursor: pointer;
    transition: all 0.2s ease;
    min-width: 100px;

    &:hover {
        background-color: ${color.darkGray};
    }
`;

export const ConfirmButton = styled.button`
    padding: 10px 20px;
    font-size: 14px;
    font-weight: 500;
    color: ${color.white};
    background-color: ${color.lightningYellow};
    border: none;
    border-radius: 20px;
    cursor: pointer;
    transition: all 0.2s ease;
    min-width: 100px;

    &:hover {
        background-color: ${color.yellow60};
    }
`;

export const CloseButtonContainer = styled.div`
    position: absolute;
    right: 8px;
    top: 8px;
`;

export const DialogPaperProps = {
    sx: {
        backgroundColor: color.darkBlue,
        color: color.white,
        padding: '20px',
        borderRadius: '8px',
        margin: '16px',
        maxWidth: '600px',
        position: 'relative'
    }
};
